// extracted by mini-css-extract-plugin
export default {"header":"CustomColors_header__f-OWA","list":"CustomColors_list__6cw7w"};